// imports
import clsx from 'clsx';
import React from 'react';
import { IMAGE } from '../../../assets';
import { MapViewState, World } from '../../../common/types';
import { ELYSIA_REGION_ID } from '../../../constants/lib/map';

// interfaces / types / consts
interface Props {
  world: World;
  regionHovered: boolean;
  mapViewState: MapViewState;
}

// exports
export default function BannerLayer(props: Props): JSX.Element {
  const { world, regionHovered, mapViewState } = props;
  // render
  return (
    <div className={clsx('banner-layer', regionHovered && mapViewState === 'default' ? 'opacity-1' : 'opacity-0')}>
      <img src={IMAGE.MAP_REGION_BANNER} alt="banner" />
      <span className="region-text">{world.regions && world.regions[ELYSIA_REGION_ID]?.name}</span>
    </div>
  );
}
